import React from "react"
import { ControlledDatePicker } from "../../../Core/Form/Datepickers";
import { QuoteContextStore } from '../../../../context/QuoteContext/QuoteContext';
import { useContext } from "react"
import dayjs from 'dayjs';


const StartTimeDatePicker = () => {
    const { changeStartDate } = useContext(QuoteContextStore);
    const now = new Date();
    const handleDateChange = async (val) => {
        let now = new Date()
        const selected = new Date(val)
        selected.setHours(now.getHours())
        selected.setMinutes(now.getMinutes())
        await changeStartDate(dayjs(selected).format())
    }

    return <ControlledDatePicker maxDate={new Date(now.setMonth(now.getMonth() + 3))} disablePast fullWidth name="start_date" onChange={handleDateChange}/>
}

export default StartTimeDatePicker